const isObjectTag = tagType => {
  return [
    "IMAGE_EXT",
    "IMAGE_MINIATURE",
    "IMAGE_GALLERY",
    "SCHEDULE",
    "FILE_EXT"
  ].includes(tagType);
};
const isArrayTag = tagType => {
  return ["TAGS"].includes(tagType);
};
const getEmptyByTag = tagType => {
  if (tagType == "IMAGE_GALLERY") {
    return {
      items: []
    };
  }
  if (tagType == "SCHEDULE") {
    return {
      typ: 0,
      dt_begin: "",
      dt_end: "",
      dates: [],
      times: []
    };
  }
  if (isObjectTag(tagType)) return {};
  if (isArrayTag(tagType)) return [];
  return "";
};

export { isObjectTag, isArrayTag, getEmptyByTag };
